import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {API} from '../../config/api';


@Injectable()
export class ToolsService {

  constructor(private httpClient: HttpClient) { }

  studentQuestionnaireSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.STUDENT_QUESTIONNAIRE_SUMMARY, payload);
  }

  teacherQuestionnaireSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.TEACHER_QUESTIONNAIRE_SUMMARY, payload);
  }

  principalQuestionnaireDataSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.PRINCIPAL_QUESTIONNAIRE_DATA_SUMMARY, payload);
  }

  studentQuestionnaire(payload: any): Observable<any> {
    // return this.httpClient.post(API.STUDENT_QUESTIONNAIRE_ANSWERS, payload);
    return this.httpClient.post(API.STUDENT_QUESTIONNAIRES, payload);
  }

  saveStudentQuestionnaireAnswer(payload: any[]): Observable<any> {
    return this.httpClient.post(API.STUDENT_QUESTIONNAIRE_ANSWERS, payload);
  }

  teacherQuestionnaire(payload: any): Observable<any> {
    return this.httpClient.post(API.TEACHER_QUESTIONNAIRES, payload);
  }

  saveTeacherQuestionnaireAnswer(payload: any[]): Observable<any> {
    return this.httpClient.post(API.TEACHER_QUESTIONNAIRE_ANSWERS, payload);
  }

  principalQuestionnaire(payload: any): Observable<any> {
    return this.httpClient.post(API.PRINCIPAL_QUESTIONNAIRES, payload);
  }

  savePrincipalQuestionnaireAnswer(payload: any[]): Observable<any> {
    return this.httpClient.post(API.PRINCIPAL_QUESTIONNAIRE_ANSWERS, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/tools.service.ts